import { render, staticRenderFns } from "./CustomerDetails.vue?vue&type=template&id=ff64f99a&scoped=true&"
import script from "./CustomerDetails.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetails.vue?vue&type=style&index=0&id=ff64f99a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff64f99a",
  null
  
)

export default component.exports